const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ components
const ScheduledTransfersFilters = require('./scheduledTransfersFilters/scheduledTransfersFilters');
const { ScheduledTransfersContent } = require('./scheduledTransfersContent/scheduledTransfersContent');

class ScheduledTransfers extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filtersSectionOpen: false
        }

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.handleSetFilters = this.handleSetFilters.bind(this);
        this.handleResetFilter = this.handleResetFilter.bind(this);
        this.handleClearFilters = this.handleClearFilters.bind(this);
    }

    componentDidMount() {
        const { requestScheduledTransfers, immAccount } = this.props;
        const accountId = immAccount.get('accountId');
        requestScheduledTransfers(accountId);
    }

    componentDidUpdate(prevProps) {
        const accountId = this.props.immAccount.get('accountId');
        const prevAccountId = prevProps.immAccount.get('accountId');

        if (accountId !== prevAccountId) {
            this.props.requestScheduledTransfers(accountId);
        }
    }

    handleClearFilters() {
        const { immAccount, clearFilters, requestScheduledTransfers } = this.props;
        const accountId = immAccount.get('accountId');

        clearFilters();
        requestScheduledTransfers(accountId);
    }

    handleResetFilter(filters) {
        const { immAccount, resetFilter, requestScheduledTransfers } = this.props;
        const accountId = immAccount.get('accountId');
        //In same cases, we need to reset more than one filter at once
        filters.forEach(filter => {
            resetFilter(filter);
        });
        requestScheduledTransfers(accountId);
    }

    handleSetFilters(filters) {
        const { immAccount, setFilters, requestScheduledTransfers } = this.props;
        const accountId = immAccount.get('accountId');

        setFilters(filters);
        requestScheduledTransfers(accountId);
    }

    handleToggleFilters() {
        this.setState({
            filtersSectionOpen: !this.state.filtersSectionOpen
        });
    }

    render() {
        const {
            immScheduledTransfers,
            immAccount,
            immScreen,
            isInactiveAccountsEnabled,
            requestScheduledTransfersNextPage,
            requestScheduledTransfers
        } = this.props;

        const immFilter = immScheduledTransfers.get('filters');
        const accountCurrency = immAccount.get('balance').get('currency');

        return (
            <div>
                <ScheduledTransfersFilters
                    accountCurrency={accountCurrency}
                    immFilter={immFilter}
                    isOpen={this.state.filtersSectionOpen}
                    onCloseClick={this.handleToggleFilters}
                    onSetFilters={this.handleSetFilters}
                />
                <ScheduledTransfersContent
                    immScheduledTransfers={immScheduledTransfers}
                    immAccounts={this.props.immAccounts}
                    immAccount={immAccount}
                    immFilter={immFilter}
                    immScreen={immScreen}
                    isInactiveAccountsEnabled={isInactiveAccountsEnabled}
                    requestScheduledTransfers={requestScheduledTransfers}
                    onFilterClick={this.handleToggleFilters}
                    onResetFilter={this.handleResetFilter}
                    onClearFilters={this.handleClearFilters}
                    requestScheduledTransfersNextPage={requestScheduledTransfersNextPage}
                />
            </div>
        );
    }
}

ScheduledTransfers.propTypes = {
    immScheduledTransfers: PropTypes.object.isRequired,
    immAccount: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    requestScheduledTransfers: PropTypes.func.isRequired,
    setFilters: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
    requestScheduledTransfersNextPage: PropTypes.func.isRequired
};

module.exports = ScheduledTransfers;
